import { createContext } from 'react';
export const defaultContext = {
  navigation: {
    title: process.env.APP_DISPLAY_NAME
  },
  actionSheet: {}
};
export const Context = createContext(defaultContext);
